module.exports = __webpack_public_path__ + "img/equally.7ccd5d5b.svg";